import module from 'fan/proyecto/module.js'

export const EmpleadosEmpleadoIncapacidadesSchema = {
  deduccion_valor: 'number',
  tipo_id: 'number',
  fecha_inicial: 'date',
  fecha_final: 'date',
  importe: 'number',
  concluido: 'boolean',
}

export class FanProyectoColaboradoresCreditosMasivosFonacot {
  constructor ($http){
    this.$http = $http
  }

  post (colaborador_id, proyecto_id, data){
    return this.$http.post('/api/empleados/empleado/creditos', data,{
      params: {colaborador_id, proyecto_id}
    })
  }
}

module.service('fanProyectoColaboradoresCreditosMasivosFonacot', FanProyectoColaboradoresCreditosMasivosFonacot)


// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Colaboradores/Creditos/Fonacot.js